module.exports = __webpack_public_path__ + "img/11.cce1aded.jpg";